// Generated by purs version 0.14.4
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
var StatusCode = function (x) {
    return x;
};
var showStatusCode = {
    show: function (v) {
        return "(StatusCode " + (Data_Show.show(Data_Show.showInt)(v) + ")");
    }
};
var newtypeStatusCode = {
    Coercible0: function () {
        return undefined;
    }
};
var eqStatusCode = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var ordStatusCode = {
    compare: function (x) {
        return function (y) {
            return Data_Ord.compare(Data_Ord.ordInt)(x)(y);
        };
    },
    Eq0: function () {
        return eqStatusCode;
    }
};
export {
    StatusCode,
    eqStatusCode,
    ordStatusCode,
    newtypeStatusCode,
    showStatusCode
};
//# sourceMappingURL=index.js.map
